import { siteManagerAccessStatusToLabel } from "encamp-shared/src/waste/index";
import { SiteManagerAccessStatus } from "generated-graphql/graphql";

/**
 * Why RCRA site manager access matters — shared copy for everywhere the
 * per-EPA-ID access state is surfaced (facility list column, facility details
 * tile, manifest summary line).
 */
export const SITE_MANAGER_ACCESS_TOOLTIP =
  "RCRA site manager access is granted per facility EPA ID, not per manifest. " +
  "Without it, we can't pull RCRAInfo data for this EPA ID sooner than 90 days " +
  "(from the public export), and can't guarantee a timely response to EPA " +
  "correction requests.";

export const SITE_MANAGER_ACCESS_REQUEST_SUFFIX =
  "Reach out to your Encamp contact to request access.";

/** Filter options for the tri-state access fact, most actionable first. */
export const SITE_MANAGER_ACCESS_FILTER_VALUES = [
  SiteManagerAccessStatus.Granted,
  SiteManagerAccessStatus.None,
  SiteManagerAccessStatus.Unknown,
];

// Takes plain string so it can double as the filter popover's
// enumPresentationFunction, which is typed over raw enum value strings.
export const siteManagerAccessToLabel = (status: string | null | undefined): string =>
  siteManagerAccessStatusToLabel(status);
